import { Box, CircularProgress, Stack, Typography, useTheme } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import IlmoLogoBlack from "../../assets/graphics-black/ilmo_logo.svg";
import IlmoLogoWhite from "../../assets/graphics-white/ilmo_logo.svg";
import IlmoOnlineLogoBlack from "../../assets/graphics-black/ilmo_online_logo.svg";
import IlmoOnlineLogoWhite from "../../assets/graphics-white/ilmo_online_logo.svg";
import { Capacitor } from "@capacitor/core";
import { useEffect } from "react";
import { SplashScreen } from "@capacitor/splash-screen";


export default function LoadingPage({ text, inside }: { text?: string, inside?: boolean }) {
  const theme = useTheme();

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      SplashScreen.show();
    }
    return () => {
      SplashScreen.hide();
    };
  }, []);

  /* useEffect(() => {
    const timer = setTimeout(() => {
      window.location.reload();
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, []); */

  return (
    <Box height={inside ? "100%" : "100vh"} width={inside ? "100%" : "100vw"} display="flex" alignItems="center" justifyContent="center">
      <Stack direction="column" alignItems="center" justifyContent="space-around" spacing={6} height="100%" padding={6} width="100%">
        <Typography width="100%" textAlign="center" fontWeight={600}>Ladataan...</Typography>
        <CircularProgress size={24} thickness={4} />
      </Stack>
    </Box>
  );
}